import BaseCommand from "@/models/api/commands/BaseCommand";

export interface ChangeAttributeParam {
  Value: string;
  IsPrintable: boolean;
  AttributeTmpId: string;
  BookingItemTmpId: string;
}

export class ChangeAttributeCommand extends BaseCommand {
  CommandName = "ChangeAttribute";
  Command: ChangeAttributeParam;
  constructor(sessionId: string, operationId: string, changeAttributeParam: ChangeAttributeParam) {
    super(sessionId, operationId);
    this.Command = changeAttributeParam;
  }
}
